"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicFunction = void 0;
const __1 = require("../");
const BFParameters_1 = require("./BFParameters");
const ExecutableItem_1 = require("./ExecutableItem");
const Guard_1 = require("./Guard");
class BasicFunction extends ExecutableItem_1.ExecutableItem {
    constructor(bFunction, extras) {
        super();
        this.extras = extras;
        this.parameters = {};
        this.executableType = ExecutableItem_1.ExecutableType.BasicFunction;
        this.name = bFunction.name;
        this.system = !!bFunction.system;
        const isValidBFID = extras.isBfIDValid(bFunction.refId);
        if (!isValidBFID) {
            throw new Error('Basic function refIds should be unique.');
        }
        this.refId = bFunction.refId;
        this.guards = Guard_1.Guard.arrayFactory(bFunction.guards || []);
        if (bFunction.parameters) {
            this.parameters = Object.keys(bFunction.parameters).reduce((acc, key) => {
                const val = bFunction.parameters && bFunction.parameters[key];
                acc[key] = BFParameters_1.parameterFactory(val, this.extras);
                return acc;
            }, {});
        }
    }
    isComplete() {
        return this.userModeExecStatus.isComplete;
    }
    isFirstNodeASystemAction() {
        return this.system;
    }
    isNodeInProgress() {
        // Basic funtion is never in progress. This is more for the execution group.
        return false;
    }
    // TODO: this can a non async function
    validate(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const guardRes = Guard_1.Guard.evaluateAll(this.guards, this.extras, this);
            if (!guardRes.proceed) {
                return this.skipNode();
            }
            if (this.extras.getProhibition()) {
                // some prohibition accumilated before this node
                if (this.system) {
                    // this should never happen, validation should not happen on a system node
                    throw new Error('Validation cannot happen on system Basic Function');
                }
                else {
                    const prevNodeTime = +this.extras.logger.lastLogTime();
                    const currTime = Date.now();
                    if (!prevNodeTime) {
                        throw new Error('');
                    }
                    const mes = `Need to wait a min of ${this.extras.getProhibition()}ms only ${currTime - prevNodeTime} ms has passed`;
                    this.extras.logger.debug(mes);
                    if (currTime - prevNodeTime < this.extras.getProhibition()) {
                        // throw new Error(mes);
                        this.extras.doControlEmit(__1.ControlActions.GuardViolation, mes);
                        return {
                            result: false,
                            skipped: false,
                        };
                    }
                }
                this.extras.resetProhibition();
            }
            // assecc structural integrity first
            let structuralIntegrityValid = true;
            if (!value.name ||
                !value.parameters ||
                Object.keys(this.parameters).length !==
                    Object.keys(value.parameters).length) {
                structuralIntegrityValid = false;
            }
            if (!structuralIntegrityValid) {
                return {
                    result: false,
                    skipped: false,
                };
            }
            const isValid = Object.keys(this.parameters).reduce((acc, key) => {
                if (!acc) {
                    //if already invalidated on one parameter, just keep saying its a failed validation
                    return false;
                }
                const val = this.parameters[key];
                return val.isEqual(value.parameters[key]);
            }, this.name === value.name);
            if (isValid) {
                Object.keys(value.parameters).forEach((key) => {
                    this.extras.store.setVariable(this.refId, key, value.parameters[key]);
                });
                this.markComplete();
            }
            return { result: isValid, skipped: false };
        });
    }
    hasMoreSystemActions() {
        return this.system;
    }
    consumeGuardFailingNodes() {
        return __awaiter(this, void 0, void 0, function* () {
            const guardRes = Guard_1.Guard.evaluateAll(this.guards, this.extras, this, true);
            if (guardRes.proceed) {
                return true;
            }
            return this.passiveModeSkip();
        });
    }
    getSystemAction() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isComplete()) {
                // for system actions skipped and completed are equivalent.
                return {
                    skipped: true,
                    result: null,
                };
            }
            // this.extras.logger.debug({ msg: '========= Debug evaluation =======' });
            const guardRes = Guard_1.Guard.evaluateAll(this.guards, this.extras, this);
            // this.extras.logger.debug({
            //   name: this.name,
            //   msg: '========= Debug evaluation end =======',
            //   guardRes,
            //   guard: this.guards,
            // });
            if (!guardRes.proceed) {
                return this.skipNode();
            }
            if (this.extras.getProhibition()) {
                if (this.system) {
                    this.extras.doEmitDelay(this.extras.getProhibition());
                    this.extras.resetProhibition();
                }
                else {
                    // this should never happen
                    throw new Error('Invalid Lesson state, trying to fire a system action as non-system action');
                }
            }
            this.markComplete();
            return {
                skipped: false,
                result: this.getValToEmit(),
            };
        });
    }
    getValToEmit() {
        const prarameterValues = Object.keys(this.parameters).reduce((acc, key) => {
            acc[key] = this.parameters[key].getValToEmit();
            this.extras.store.setVariable(this.refId, key, acc[key]);
            return acc;
        }, {});
        return {
            name: this.name,
            parameters: prarameterValues,
        };
    }
    reset() {
        this.userModeExecStatus.isComplete = false;
    }
}
exports.BasicFunction = BasicFunction;
//# sourceMappingURL=data:application/json;base64,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